import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { navigationService } from 'src/config/rootService';
import { ProgramPreviewFragment } from 'src/modules/newPrograms/documents/getProgram.generated';
import { ContentCard } from 'src/shared/components/ContentCard';

interface ProgramCardProps {
    program: ProgramPreviewFragment;
}
export const ProgramCard: FC<ProgramCardProps> = ({ program }) => {
    const { t } = useTranslation();

    const handleProgramSelect = () => {
        navigationService.navigate(`/programs?uuid=${program.uuid}`);
    };

    return (
        <ContentCard
            title={program.name ?? ''}
            image={program.image ?? ''}
            firstInfoText={t('programs:components.program_card_row.description')}
            secondInfoText={t('programs:components.program_card_row.duration', {
                duration: program.duration || 1,
            })}
            onClick={handleProgramSelect}
            isCompleted={!!program.isCompleted}
        />
    );
};
